"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { DropInteractionParams, DropLocation } from "../Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useCallback, useState } from "react";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "../WaveDropActions";
import WaveDropMobileMenu from "../WaveDropMobileMenu";
import WaveDropAuthorPfp from "../WaveDropAuthorPfp";
import ParticipationDropContainer from "./ParticipationDropContainer";
import ParticipationDropHeader from "./ParticipationDropHeader";
import ParticipationDropContent from "./ParticipationDropContent";
import ParticipationDropMetadata from "./ParticipationDropMetadata";
import ParticipationDropFooter from "./ParticipationDropFooter";
interface OngoingParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
}
export default function OngoingParticipationDrop(t0) {
  const $ = _c(58);
  const {
    drop,
    showWaveInfo,
    activeDrop,
    showReplyAndQuote,
    location,
    onReply,
    onQuote,
    onQuoteClick,
    onDropContentClick
  } = t0;
  const isActiveDrop = activeDrop?.drop.id === drop.id;
  const isMobile = useIsMobileDevice();
  const [activePartIndex, setActivePartIndex] = useState(0);
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [isSlideUp, setIsSlideUp] = useState(false);
  let t1;
  if ($[0] !== isMobile) {
    t1 = () => {
      if (!isMobile) {
        return;
      }
      setLongPressTriggered(true);
      setIsSlideUp(true);
    };
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLongPress = t1;
  let t2;
  if ($[2] !== activePartIndex || $[3] !== drop || $[4] !== onReply) {
    t2 = () => {
      setIsSlideUp(false);
      onReply({
        drop,
        partId: drop.parts[activePartIndex]?.part_id
      });
    };
    $[2] = activePartIndex;
    $[3] = drop;
    $[4] = onReply;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOnReply = t2;
  let t3;
  if ($[6] !== activePartIndex || $[7] !== drop || $[8] !== onQuote) {
    t3 = () => {
      setIsSlideUp(false);
      onQuote({
        drop,
        partId: drop.parts[activePartIndex]?.part_id
      });
    };
    $[6] = activePartIndex;
    $[7] = drop;
    $[8] = onQuote;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleOnQuote = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsSlideUp(false);
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleOnAddReaction = t4;
  let t5;
  if ($[11] !== activePartIndex || $[12] !== drop || $[13] !== handleOnQuote || $[14] !== handleOnReply || $[15] !== isMobile || $[16] !== showReplyAndQuote) {
    t5 = !isMobile && showReplyAndQuote && <WaveDropActions drop={drop} activePartIndex={activePartIndex} showVoting={false} onReply={handleOnReply} onQuote={handleOnQuote} />;
    $[11] = activePartIndex;
    $[12] = drop;
    $[13] = handleOnQuote;
    $[14] = handleOnReply;
    $[15] = isMobile;
    $[16] = showReplyAndQuote;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== drop) {
    t6 = <WaveDropAuthorPfp drop={drop} />;
    $[18] = drop;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== drop || $[21] !== showWaveInfo) {
    t7 = <ParticipationDropHeader drop={drop} showWaveInfo={showWaveInfo} />;
    $[20] = drop;
    $[21] = showWaveInfo;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== activePartIndex || $[24] !== drop || $[25] !== handleLongPress || $[26] !== onDropContentClick || $[27] !== onQuoteClick) {
    t8 = <ParticipationDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={handleLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={true} />;
    $[23] = activePartIndex;
    $[24] = drop;
    $[25] = handleLongPress;
    $[26] = onDropContentClick;
    $[27] = onQuoteClick;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t7 || $[30] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-w-full tw-gap-y-1.5">{t7}{t8}</div>;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t6 || $[33] !== t9) {
    t10 = <div className="tw-flex tw-gap-x-3 tw-relative tw-z-10 tw-w-full tw-text-left tw-bg-transparent tw-border-0 tw-px-4 tw-pt-4">{t6}{t9}</div>;
    $[32] = t6;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== drop.id || $[36] !== drop.metadata) {
    t11 = <ParticipationDropMetadata metadata={drop.metadata} contextId={drop.id} />;
    $[35] = drop.id;
    $[36] = drop.metadata;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== drop) {
    t12 = <ParticipationDropFooter drop={drop} />;
    $[38] = drop;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t11 || $[41] !== t12) {
    t13 = <div className="tw-flex tw-w-full tw-flex-col">{t11}{t12}</div>;
    $[40] = t11;
    $[41] = t12;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== drop || $[44] !== handleOnQuote || $[45] !== handleOnReply || $[46] !== isSlideUp || $[47] !== longPressTriggered || $[48] !== showReplyAndQuote) {
    t14 = <WaveDropMobileMenu drop={drop} isOpen={isSlideUp} longPressTriggered={longPressTriggered} showReplyAndQuote={showReplyAndQuote} setOpen={setIsSlideUp} onReply={handleOnReply} onQuote={handleOnQuote} onAddReaction={handleOnAddReaction} />;
    $[43] = drop;
    $[44] = handleOnQuote;
    $[45] = handleOnReply;
    $[46] = isSlideUp;
    $[47] = longPressTriggered;
    $[48] = showReplyAndQuote;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== drop || $[51] !== isActiveDrop || $[52] !== location || $[53] !== t10 || $[54] !== t13 || $[55] !== t14 || $[56] !== t5) {
    t15 = <ParticipationDropContainer drop={drop} isActiveDrop={isActiveDrop} location={location}>{t5}{t10}{t13}{t14}</ParticipationDropContainer>;
    $[50] = drop;
    $[51] = isActiveDrop;
    $[52] = location;
    $[53] = t10;
    $[54] = t13;
    $[55] = t14;
    $[56] = t5;
    $[57] = t15;
  } else {
    t15 = $[57];
  }
  return t15;
}